import { render, staticRenderFns } from "./ChatThread.vue?vue&type=template&id=01c888f8&scoped=true"
import script from "./ChatThread.vue?vue&type=script&lang=js"
export * from "./ChatThread.vue?vue&type=script&lang=js"
import style0 from "./ChatThread.vue?vue&type=style&index=0&id=01c888f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c888f8",
  null
  
)

export default component.exports